/**
 * Backend returns only rows with date >= (today - days). The chart window’s first visible
 * trading day still needs the prior session’s close for daily % change; without extra depth
 * the oldest bar in the payload is exactly that day and prior close is missing from the array.
 */
export const HISTORICAL_PRICES_API_EXTRA_DAYS = 45;
